module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n  <ul id="graphTab" class="nav nav-tabs">\n    ';

      let enterpriseGraphClass = '';
      let graphClass = '';
      if (frontendConfig.isEnterprise) {
        // In case we do have an Enterprise intance up and running, EnterpriseGraphs will be our default ...
        enterpriseGraphClass = "active"
      } else {
        // ... otherwise, general graphs will be.
        graphClass = "active";
      }
    
__p+='\n    <li class="'+
((__t=(enterpriseGraphClass))==null?'':__t)+
'"><a href="#enterpriseGraph" data-toggle="tab" id="tab-enterpriseGraph">EnterpriseGraph</a></li>\n    <li><a href="#smartGraph" data-toggle="tab" id="tab-smartGraph">SmartGraph</a></li>\n    <li class="'+
((__t=(graphClass))==null?'':__t)+
'"><a href="#createGraph" data-toggle="tab" id="tab-createGraph">GeneralGraph</a></li>\n    <li><a href="#satelliteGraph" data-toggle="tab" id="tab-satelliteGraph">SatelliteGraph</a></li>\n    <li><a href="#exampleGraphs" data-toggle="tab" id="tab-exampleGraphs">Examples</a></li>\n  </ul>\n\n  <div class="tab-content" id="tab-content-create-graph">\n\n    <div class="tab-pane" id="exampleGraphs">\n      <table style="margin-bottom: 10px">\n        <tbody>\n          <tr>\n            <td>Knows Graph</td>\n            <td>\n              <button style="float: right; margin-bottom: 10px;" graph-id="knows_graph" class="button-success createExampleGraphs">Create</button>\n            </td>\n          </tr>\n          <tr>\n            <td>Traversal Graph</td>\n            <td>\n              <button style="float: right; margin-bottom: 10px;" graph-id="traversalGraph" class="button-success createExampleGraphs">Create</button>\n            </td>\n          </tr>\n          <tr>\n            <td>k Shortest Paths Graph</td>\n            <td>\n              <button style="float: right; margin-bottom: 10px;" graph-id="kShortestPathsGraph" class="button-success createExampleGraphs">Create</button>\n            </td>\n          </tr>\n          <tr>\n            <td>Mps Graph</td>\n            <td>\n              <button style="float: right; margin-bottom: 10px;" graph-id="mps_graph" class="button-success createExampleGraphs">Create</button>\n            </td>\n          </tr>\n          <tr>\n            <td>World Graph</td>\n            <td>\n              <button style="float: right; margin-bottom: 10px;" graph-id="worldCountry" class="button-success createExampleGraphs">Create</button>\n            </td>\n          </tr>\n          <tr>\n            <td>Social Graph</td>\n            <td>\n              <button style="float: right; margin-bottom: 10px;" graph-id="social" class="button-success createExampleGraphs">Create</button>\n            </td>\n          </tr>\n          <tr>\n            <td>City Graph</td>\n            <td>\n              <button style="float: right; margin-bottom: 10px;" graph-id="routeplanner" class="button-success createExampleGraphs">Create</button>\n            </td>\n          </tr>\n          <tr>\n            <td>Connected Components Graph</td>\n            <td>\n              <button style="float: right; margin-bottom: 10px;" graph-id="connectedComponentsGraph" class="button-success createExampleGraphs">Create</button>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n     <p style="width: 100%; text-align: center;">Need help? Visit our <a style="font-weight: bold" href="https://www.arangodb.com/docs/stable/graphs.html#example-graphs" target="_blank">Graph Documentation</a></p>\n\n    </div>\n\n    <div class="active tab-pane" id="createGraph">\n\n    ';

      let smartGraphInfoStyle = "font-weight: 400;";
      if (!frontendConfig.isEnterprise) {
        // In case if we do not have an Enterprise instance, we must hide this by default.
        smartGraphInfoStyle = "display: none;"
      }
    
__p+='\n\n    <div id="smartGraphInfo" class="alert alert-info" style="'+
((__t=(smartGraphInfoStyle))==null?'':__t)+
'">\n      <span><i class="fa fa-info-circle"></i></span>\n      <span>Only use non-existent collection names. They are automatically created during the graph setup.</span>\n    </div>\n\n    <div id="smartGraphInfoOneShard" class="infoMessage" style="display: none">\n      <span>Creating SmartGraphs in a OneShard database is discouraged. SmartGraphs only make sense when data are actually distributed, which is exactly opposite to the purpose of the OneShard feature. Using a SmartGraph in a OneShard database may lead to some OneShard query optimizations being disabled.</span>\n    </div>\n\n    ';

    var createTR = function(row, disableSubmitOnEnter) {
      var mandatory = '';
      if (row.mandatory) {
        mandatory = '*';
      }
      var cssClass = '';
      if (row.cssClass) {
        cssClass = row.cssClass;
      }

      
__p+='\n        <tr class="tableRow '+
((__t=(cssClass))==null?'':__t)+
'" id="'+
((__t=('row_' + row.id))==null?'':__t)+
'">\n          ';
 if (row.removeColon) { 
__p+='\n          <th class="collectionTh">'+
((__t=(row.label))==null?'':__t)+
''+
((__t=(mandatory))==null?'':__t)+
'</th>\n          ';
 } else { 
__p+='\n            <th class="collectionTh">'+
((__t=(row.label))==null?'':__t)+
''+
((__t=(mandatory))==null?'':__t)+
':</th>\n          ';
 } 
__p+='\n\n          <th class="collectionTh">\n            ';

              switch(row.type) {
                case "text":
            
__p+='\n            <input type="text" id="'+
((__t=(row.id))==null?'':__t)+
'" value="'+
((__t=(row.value||''))==null?'':__t)+
'" placeholder="'+
((__t=(row.placeholder||''))==null?'':__t)+
'"></input>\n            ';

                break;
              case "password":
            
__p+='\n            <input type="password" id="'+
((__t=(row.id))==null?'':__t)+
'" value="'+
((__t=(row.value||''))==null?'':__t)+
'" placeholder="'+
((__t=(row.placeholder||''))==null?'':__t)+
'"></input>\n            ';

              break;
            case 'spacer':
            
__p+='\n            <div class="modal-spacer" id="'+
((__t=( row.id  ))==null?'':__t)+
'"></div>\n            ';

                break;
              case "readonly":
            
__p+='\n            <input type="text" id="'+
((__t=(row.id))==null?'':__t)+
'" value="'+
((__t=(row.value||''))==null?'':__t)+
'" placeholder="'+
((__t=(row.placeholder||''))==null?'':__t)+
'" disabled></input>\n            ';

                break;
                case "checkbox":
                  var checked = '',
                    disabled = '';
                  if (row.checked) {
                    checked = 'checked';
                  }
                  if (row.disabled) {
                    disabled = 'disabled';
                  }
            
__p+='\n            <input type="checkbox" id="'+
((__t=(row.id))==null?'':__t)+
'" value="'+
((__t=(row.value))==null?'':__t)+
'" '+
((__t=(checked))==null?'':__t)+
' '+
((__t=(disabled))==null?'':__t)+
'></input>\n            ';

                break;
                case "select":
                  let selectDisabled = '';
                  let selectTitle = '';
                  if (row.options && row.options.length === 1) {
                    selectDisabled = ' disabled';
                    selectTitle = 'Only one entry available.'
                  }
            
__p+='\n            <select id="'+
((__t=(row.id))==null?'':__t)+
'" class="modalSelect" '+
((__t=( selectTitle ? 'title="' + selectTitle + '"' : '' ))==null?'':__t)+
' '+
((__t=(selectDisabled))==null?'':__t)+
'>\n            ';

                  _.each(row.options, function(opt) {
            
__p+='\n              <option value="'+
((__t=(opt.value))==null?'':__t)+
'" '+
((__t=(row.selected === opt.value?"selected":""))==null?'':__t)+
'>'+
((__t=(opt.label))==null?'':__t)+
'</option>\n            ';

                  });
            
__p+='\n            </select>\n            ';

                break;
                case "select2":
            
__p+='\n            <input type="hidden" id="'+
((__t=(row.id))==null?'':__t)+
'" value="'+
((__t=(row.value||''))==null?'':__t)+
'" placeholder="'+
((__t=(row.placeholder||''))==null?'':__t)+
'"></input>\n            ';
 if (row.addAdd) {
__p+='\n              <button id="'+
((__t=('addAfter_' + row.id))==null?'':__t)+
'" class="button-success pull-right add addAfter graphViewer-icon-add-remove-button">Add relation</button>\n            ';
 } 
__p+='\n            ';
 if (row.addDelete) {
__p+='\n              <button id="'+
((__t=('remove_' + row.id))==null?'':__t)+
'" class="button-danger pull-right delete addDelete graphViewer-icon-add-remove-button">Remove relation</button>\n            ';
 } 
__p+='\n            ';

                break;
              }

              if (row.info) {
            
__p+='\n          <th>\n            <span class="modalTooltips arangoicon icon_arangodb_info" title="'+
((__t=(row.info))==null?'':__t)+
'">\n            </span>\n          </th>\n        ';

          } else {
        
__p+='\n          <th class="collectionTh"></th>\n        ';
 } 
__p+='\n        </tr>\n      ';

    }//createTR
    
__p+='\n\n    <table>\n      <tbody>\n        ';

        _.each(content, function(row) {
          createTR(row);
        });
        
__p+='\n\n      </tbody>\n    </table>\n      ';

      if (advancedContent) {
      
__p+='\n      <div class="accordion" id="accordion2">\n        <div class="accordion-group">\n          <div class="accordion-heading">\n            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion2" href="#collapseOne">\n              <span>'+
((__t=(advancedContent.header))==null?'':__t)+
'</span><span><b class="caret"></b></span>\n            </a>\n          </div>\n          <div id="collapseOne" class="accordion-body collapse out">\n            <div class="accordion-inner">\n              <table>\n                <tbody>\n                  ';

                  _.each(advancedContent.content, function(row) {
                    createTR(row);
                  });
                  
__p+='\n                </tbody>\n              </table>\n            </div>\n          </div>\n        </div>\n      </div>\n      ';

      }
      
__p+='\n    </div>\n\n  </div>\n';
}
return __p;
};
